import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, Grid, Typography } from '@material-ui/core';
import { useIsDesktop, useTranslations } from 'components/utilities';

const PriceSummaryListItem = ({ title, price, highlighted }) => {
	const { t } = useTranslations();

	const textColor = highlighted ? 'secondary' : 'inherit';

	const isDesktop = useIsDesktop();
	const textStyles = !isDesktop ? { fontSize: 16 } : null;

	return (
		<ListItem>
			<Grid container spacing={1} justify="space-between">
				<Grid item xs="auto">
					<Typography
						variant={highlighted ? 'h5' : 'body1'}
						color={textColor}
						style={textStyles}
					>
						{title}
					</Typography>
				</Grid>
				<Grid item xs="auto">
					<Typography variant="h5" color={textColor} style={textStyles}>
						{price} {t('common.sar')}
					</Typography>
				</Grid>
			</Grid>
		</ListItem>
	);
};

PriceSummaryListItem.propTypes = {
	title: PropTypes.string,
	price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	highlighted: PropTypes.bool,
};

export default PriceSummaryListItem;
